export default __webpack_public_path__ + "21cc621d3b74de4a675fd4c91407f5e7.png";